import { Box, Stack, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

/** A row of steps (RFQ … Completed, or Draft … Converted): done, where it is now, still to come */
export function StageStepper({
  steps,
  current,
  dates,
}: {
  steps: readonly string[];
  current: number;
  dates: string[];
}) {
  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Stack direction="row" sx={{ minWidth: 120 + steps.length * 60 }}>
        {steps.map((label, i) => {
          const done = i < current;
          const now = i === current;
          return (
            <Stack key={label} sx={{ flex: 1, alignItems: 'center', position: 'relative', px: 0.5 }}>
              {i > 0 && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 15,
                    right: '50%',
                    width: '100%',
                    height: 2,
                    bgcolor: i <= current ? 'success.main' : 'divider',
                  }}
                />
              )}
              <Box
                sx={{
                  position: 'relative',
                  zIndex: 1,
                  display: 'grid',
                  placeItems: 'center',
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  color: '#fff',
                  bgcolor: done ? 'success.main' : now ? 'primary.main' : 'background.paper',
                  border: 2,
                  borderColor: done ? 'success.main' : now ? 'primary.main' : 'divider',
                }}
              >
                {done && <CheckIcon fontSize="small" />}
                {now && <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#fff' }} />}
              </Box>
              <Typography variant="body2" sx={{ fontWeight: now ? 700 : 500, mt: 0.5, textAlign: 'center' }}>
                {label}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ minHeight: 18 }}>
                {dates[i] ?? ''}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
}
